import BumpGroupsContainer from './BumpGroupsContainer';

export default BumpGroupsContainer;
